import type { CourseSiteBrand } from "@bodemleven/course-kit/react";

export const brand: CourseSiteBrand = {
  name: "Bodemleven",
  tagline: { nl: "Analyse en Herstel", en: "Analysis and Restoration" },
  logoSrc: "/logo-mark.svg",
  homeUrl: "https://bodemleven.com",
};
